import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { Toast } from "primereact/toast";
import { useCallback, useEffect, useRef, useState } from "react";
import { CustomBreadcrumb } from "../../../shared/components/custom-breadcrumb/custom-breadcrumb";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { SERVICES } from "../../../core/services/services";
import { FRONTOFFICE_API } from "../../../core/apis/frontoffice-apis";
import { HELPER } from "../../../shared/helper/helper";
import { Optional } from "../../../shared/components/optional/optional";

export function FrontOfficeIntegrationDetails() {
  const toast = useRef(null);
  const [clientCredentials, setClientCredentials] = useState({});
  const [loading, setLoading] = useState(false);

  const handleError = useCallback((error) => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: HELPER.PROCESS_ERROR(error, "TOAST"),
      life: 10000,
    });
  }, []);

  const getClientCredentials = useCallback(() => {
    SERVICES.MAKE_GET_REQUEST(FRONTOFFICE_API.GET_CLIENT_CREDENTIALS, null)
      .then((data) => {
        console.log("cred", data);
        setClientCredentials(data?.result);
      })
      .catch((error) => {
        handleError(error);
      });
  }, [handleError]);

  useEffect(() => {
    getClientCredentials();
  }, [getClientCredentials]);

  function regenerateClientSecret() {
    setLoading(true);
    const url = FRONTOFFICE_API.RESET_CLIENT_SECRET;
    SERVICES.MAKE_PUT_REQUEST(url)
      .then((data) => {
        // console.log("reset-response", data);
        // getClientCredentials();
        setClientCredentials(data?.result);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: `Client Secret has been re-generated successfully.`,
          life: 10000,
        });
        setLoading(false);
      })
      .catch((error) => {
        handleError(error);
        setLoading(false);
      });
  }

  return (
    <ErrorBoundary>
      <div className="integration-details-wrapper">
        <div>
          <Toast ref={toast} />
        </div>
        <div className="page-title p-text-left">Integration Details</div>
        <div className="p-mt-2">
          <CustomBreadcrumb page={"Manage Integration Details"} />
        </div>
        <div className="card p-mt-5">
          {/* <form onSubmit={submit}> */}
          <div className="form-container">
            {/* <div className="">
                <p className="title">Fill form below to change your password</p>
                <p className="custom-dialog-subtitle">* Required Fields</p>
              </div> */}
            <div>
              {/* <div>
                <label>Name:</label>
                <FormInput
                  value={merchantName}
                  type="INPUT"
                  error={false}
                  disabled={true}
                  placeholder=""
                  id="name"
                  noFloatingLabel
                />
              </div>
              <br /> */}
              <div className="p-mt-3">
                <label>Client ID:</label>
                <FormInput
                  value={clientCredentials?.clientId}
                  type="INPUT"
                  error={false}
                  disabled={true}
                  placeholder=""
                  id="client-id"
                  noFloatingLabel
                />
              </div>
              <br />
              <div style={{ position: "relative" }} className="p-mt-3">
                <label>Client Secret:</label>
                <FormInput
                  value={clientCredentials?.clientSecret}
                  required={true}
                  type="INPUT"
                  disabled={true}
                  placeholder=""
                  inputType="password"
                  id="client-secret"
                  noFloatingLabel
                />
                <Optional
                  show={HELPER.HAS_AUTHORITY(
                    "fo_dd_regenerate_facilitator_secret"
                  )}
                >
                  <div
                    style={{
                      position: "absolute",
                      right: "-8rem",
                      bottom: "0.75rem",
                    }}
                  >
                    {loading ? (
                      <i
                        className="pi pi-spin pi-spinner p-ml-3"
                        style={{ fontSize: "1rem", color: "#0371AC" }}
                      ></i>
                    ) : (
                      <button
                        className="bare-button p-ml-3"
                        onClick={regenerateClientSecret}
                      >
                        <i
                          className="pi pi-refresh"
                          style={{ paddingBottom: "0", fontSize: "0.75rem" }}
                        />{" "}
                        Regenerate
                      </button>
                    )}
                  </div>
                </Optional>
              </div>
              {/* <div>
                  <div className="p-mt-5">
                    {!loading ? (
                      <div>
                        <button
                          disabled={!isValidForm}
                          onClick={submit}
                          className="primary-button"
                        >
                          Submit
                        </button>
                      </div>
                    ) : (
                      <div>
                        <CustomLoader loadingText={"loading..."} />
                      </div>
                    )}
                  </div>
                </div> */}
            </div>
          </div>
          {/* </form> */}
        </div>
      </div>
    </ErrorBoundary>
  );
}
